import { IBudgetUnitAddEditRequest } from '../../../../model/sge/budget-unit/request/budget-unit-add-edit-request';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

export type BudgetUnitField = 'year' | 'code' | 'name';

export function toBudgetUnitForm(data?: IBudgetUnitResponse, currentYear = new Date().getFullYear()): IBudgetUnitAddEditRequest {
    return data ? { year: data.year, code: data.code, name: data.name } : { year: currentYear };
}

export function validateBudgetUnit(form: IBudgetUnitAddEditRequest): ValidationErrors<BudgetUnitField> {
    const errors: ValidationErrors<BudgetUnitField> = {};
    if (isEmptyId(form.year)) errors.year = 'Exercício é obrigatório';
    if (isBlank(form.code)) errors.code = 'Código é obrigatório';
    if (isBlank(form.name)) errors.name = 'Nome é obrigatório';
    return errors;
}
